<template>
  <pui-input
    ref="editor"
    type="date"
    :disabled="editor.disabled"
    v-model="getValue"
    @change="onValueChanged"
    @blur="onBlur"
  >
  </pui-input>
</template>
<script>
import TableAttributeEditorMixin from './TableAttributeEditorMixin';

export default {
  components: {},
  mixins: [TableAttributeEditorMixin],
};
</script>
